import { Modal } from "antd";
import { memo } from "react";
import SendNotificationForm from "./SendNotificationForm";
import { useTheme } from "../../../../MainComponents/ThemeContext";

function NotificationModalForMessages({
  open,
  onCancel,
  students,
  onReset,
  tableFor,
  ...props
}) {
  const { isDark } = useTheme();

  const modalStyles = isDark
    ? {
        content: {
          background: "#151c3f",
          color: "#e2e8f0",
          border: "1px solid #3b4f7a",
          borderRadius: 16,
          boxShadow: "0 20px 50px rgba(0,0,0,0.45)",
        },
        header: {
          background: "#151c3f",
          color: "#f1f5f9",
          borderBottom: "1px solid #243056",
          marginBottom: 0,
          paddingBottom: 12,
        },
        title: {
          color: "#f8fafc",
          fontWeight: 700,
        },
        body: {
          background: "#151c3f",
          color: "#e2e8f0",
        },
        mask: {
          background: "rgba(2, 6, 23, 0.72)",
        },
      }
    : undefined;

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      width={640}
      destroyOnClose
      title="Send Notification"
      footer={null}
      {...props}
      className={`admin-send-notification-modal ${isDark ? "is-dark" : ""}${
        props.className ? ` ${props.className}` : ""
      }`}
      styles={modalStyles}
    >
      <SendNotificationForm
        onClose={onCancel}
        students={students}
        onReset={onReset}
        tableFor={tableFor}
      />
    </Modal>
  );
}

export default memo(NotificationModalForMessages);
